import React from 'react'
import PropTypes from 'prop-types'

const PurposeIcon = ({ className, id }) => (
  <svg
    className={className}
    fill="none"
    height="75"
    id={id}
    viewBox="0 0 75 75"
    width="75"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_621_460)">
      <circle cx="37.5" cy="37.5" fill="url(#paint0_linear_621_460)" r="37.5" />
      <path
        d="M48.9985 43.5518C49.0157 43.5562 49.0667 43.5718 49.1567 43.6641L49.2603 43.7852C50.997 46.0261 52.7357 48.256 54.4448 50.5059L54.4458 50.5068C54.525 50.611 54.5859 50.7607 54.6128 50.8984L54.6274 51.0303C54.6564 53.2224 54.6442 55.4136 54.6411 57.6172C54.6405 57.9386 54.5645 58.0015 54.563 58.0029C54.5473 58.0173 54.441 58.0977 54.0591 58.0977H20.8335C20.5615 58.0974 20.4206 58.0222 20.3677 57.9766C20.3431 57.9553 20.3325 57.9366 20.3267 57.9219C20.3237 57.9145 20.32 57.9034 20.3179 57.8877V57.8213C20.3179 57.8213 20.3199 57.8068 20.3306 57.7773C20.3414 57.7474 20.3577 57.7105 20.3804 57.6709L20.3813 57.6689C20.7246 57.0653 21.0746 56.4859 21.4351 55.8672H21.436C21.4613 55.8237 21.4809 55.8091 21.4917 55.8027C21.5045 55.7952 21.5382 55.7791 21.6108 55.7744L21.6099 55.7734C23.6755 55.6438 25.7314 55.5095 27.7896 55.3994C28.4788 55.3631 29.1123 55.1612 29.6626 54.624L29.6636 54.625C30.4752 53.8335 31.2733 53.1252 32.1245 52.3164C32.2663 52.1819 32.4143 52.1154 32.6567 52.0977V52.0967L39.6401 51.5566C40.3527 51.5008 40.9286 51.1742 41.3188 50.5674C41.8757 49.7013 42.4369 48.8373 42.9995 47.9717C43.5616 47.1068 44.125 46.24 44.6841 45.3701L44.6851 45.3691C44.8241 45.1529 44.987 45.0157 45.2349 44.9219L45.2358 44.9229L48.5845 43.6338C48.8603 43.5281 48.9673 43.5438 48.9985 43.5518Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        clipRule="evenodd"
        d="M34.7918 48.7828C34.921 47.4833 35.0394 46.2419 35.1701 45.0028C35.2389 44.3516 35.2489 44.3531 34.6465 44.1031C33.422 43.5948 32.1975 43.0857 30.9309 42.5591C30.7941 43.419 30.6359 44.2468 30.5365 45.0816C30.3798 46.3818 30.0786 47.6316 29.5168 48.8241C29.0658 49.7811 28.6867 50.7717 28.2877 51.7525C28.1096 52.1912 27.8337 52.4335 27.3315 52.4572C26.0465 52.5184 24.7632 52.6162 23.4072 52.7034C23.4706 52.5337 23.5142 52.4037 23.5661 52.2784C24.3389 50.4224 25.088 48.5557 25.8967 46.7158C26.2858 45.8322 26.3232 44.8951 26.4799 43.9747C26.6535 42.9573 26.7796 41.9315 26.9218 40.9087C26.947 40.7237 26.9669 40.5357 26.9669 40.3492C26.9707 38.4963 26.9691 36.6434 26.9691 34.7913V34.351C26.7888 34.4312 26.6542 34.4824 26.5281 34.5489C25.3166 35.1826 24.316 36.0586 23.5279 37.1746C23.1488 37.712 22.7872 38.2624 22.4073 38.7982C21.7844 39.6742 20.7357 39.86 19.8604 39.2592C18.9577 38.6385 18.7338 37.5859 19.3391 36.6908C20.2556 35.3347 21.1438 33.9565 22.4112 32.8787C24.7326 30.9058 27.4102 29.8861 30.457 29.9037C31.9322 29.9121 33.3777 29.7975 34.7719 29.2853C36.1218 28.7892 37.2645 27.9927 38.204 26.9012C38.8521 26.1482 39.4973 25.393 40.1623 24.6554C40.8067 23.9391 41.8294 23.8673 42.5999 24.4589C43.3688 25.049 43.6012 26.0932 43.0241 26.8584C41.9578 28.2702 40.9053 29.7027 39.4912 30.8088C38.1642 31.8468 36.6981 32.6074 35.07 33.0408C34.8078 33.1104 34.7329 33.2181 34.7344 33.4773C34.7444 35.4242 34.7444 37.3703 34.7344 39.3173C34.7329 39.571 34.8109 39.6918 35.0517 39.7866C36.0989 40.1994 37.1384 40.632 38.178 41.0654C39.1594 41.4744 39.6394 42.3282 39.5233 43.38C39.3574 44.8866 39.1976 46.3948 39.0639 47.9052C39.0287 48.3004 38.8957 48.4396 38.4891 48.464C37.4319 48.5282 36.3779 48.649 35.3223 48.7461C35.164 48.7606 35.0058 48.7682 34.7918 48.7828Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M26.79 24.1186C26.7855 21.9125 28.542 20.1506 30.7465 20.1514C32.9303 20.1514 34.7006 21.9034 34.7113 24.0758C34.722 26.2772 32.9616 28.0575 30.7686 28.0644C28.5588 28.0705 26.7946 26.3208 26.79 24.1186Z"
        fill="white"
        fillRule="evenodd"
      />
      <mask
        height="12"
        id="mask0_621_460"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
        width="12"
        x="43"
        y="16"
      >
        <path d="M43.4854 16H54.8921V27.2304H43.4854V16Z" fill="white" />
      </mask>
      <g mask="url(#mask0_621_460)">
        <path
          clipRule="evenodd"
          d="M54.8734 19.7281C54.8497 19.7939 54.8107 19.8573 54.7694 19.9147C54.2221 20.6684 53.674 21.4205 53.126 22.1727C52.8653 22.5312 52.7935 22.9279 52.8867 23.3567C53.087 24.2771 53.2888 25.1966 53.4875 26.117C53.5525 26.4204 53.3584 26.5855 53.0488 26.4854C52.1652 26.1988 51.2815 25.9113 50.3987 25.6186C50.164 25.5406 49.9255 25.5055 49.6848 25.5567C49.525 25.5918 49.3584 25.6369 49.2177 25.7172C48.4037 26.1812 47.5957 26.6566 46.7862 27.1283C46.7503 27.1489 46.7152 27.1711 46.6769 27.1887C46.44 27.298 46.2504 27.1864 46.2305 26.9265C46.2305 26.4762 46.2313 26.026 46.2321 25.5758C46.2328 25.0506 46.2405 24.5247 46.2328 23.9988C46.226 23.5815 46.0601 23.2314 45.7467 22.9508C45.0534 22.3347 44.3632 21.7163 43.6722 21.0979C43.6577 21.0857 43.6439 21.0735 43.6294 21.0605C43.3978 20.8411 43.4497 20.6019 43.7547 20.5017C44.3181 20.3167 44.8837 20.1363 45.4478 19.9536C45.804 19.839 46.1625 19.7327 46.5149 19.6066C46.8833 19.4744 47.1577 19.2259 47.3175 18.8659C47.6989 18.009 48.075 17.1506 48.4526 16.2922C48.5122 16.1584 48.5741 16.0201 48.74 16.0017C48.9059 15.9841 48.9976 16.1049 49.0832 16.2242C49.5999 16.9373 50.1266 17.6436 50.6295 18.366C50.9406 18.8132 51.3488 19.0402 51.8877 19.0861C52.7759 19.1617 53.6626 19.2603 54.5493 19.3513C54.6089 19.3574 54.6693 19.3712 54.7243 19.3941C54.8672 19.4537 54.9253 19.5814 54.8734 19.7281Z"
          fill="white"
          fillRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_621_460"
        x1="51"
        x2="-2.42889e-07"
        y1="20"
        y2="107.5"
      >
        <stop stopColor="#04817C" />
        <stop offset="1" stopColor="#002855" />
      </linearGradient>
      <clipPath id="clip0_621_460">
        <rect fill="white" height="75" width="75" />
      </clipPath>
    </defs>
  </svg>
)

PurposeIcon.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
}

export default PurposeIcon
